import React from 'react';

import Bracket from './Bracket';
import Divider from './Divider';
import Delete from './Delete';
import {AGGREGATIONS, getAggregatableVariables} from './aggregations';

function AggregateExpression({variables, operator, value, onChange, onCollapse}) {
  const targets = getAggregatableVariables(variables);
  const targetKeys = Object.keys(targets);
  const target = value[0] && value[0].var ? value[0].var : '';

  // A stored target can stop being aggregatable when its question is deleted or its type is changed.
  // Keep it in the list so the builder shows what is actually stored instead of appearing to have the
  // first question selected.
  const keys = target && targetKeys.indexOf(target) < 0 ? [target, ...targetKeys] : targetKeys;
  const labelFor = key => ((variables || {})[key] || {}).label || key;

  return (
    <Bracket onCollapse={onCollapse}>
      <select value={operator} onChange={e => onChange({[e.target.value]: value})}>
        {AGGREGATIONS.map(aggregation => (
          <option key={aggregation.value} value={aggregation.value}>
            {aggregation.label}
          </option>
        ))}
      </select>
      <Divider />
      <select
        value={target}
        style={{width: 150, textOverflow: 'ellipsis'}}
        onChange={e => onChange({[operator]: [e.target.value ? {'var': e.target.value} : null]})}>
        <option value="">Choose a question...</option>
        {keys.map(key => (
          <option key={key} value={key}>{labelFor(key)}</option>
        ))}
      </select>
      <Delete onClick={() => onChange(null)} />
    </Bracket>
  );
}

export default AggregateExpression;
